<template>
  <div v-if="addVisible">
    <el-dialog v-loading="addLoading" :title="dialogTitle" :visible.sync="addVisible" width="80%"
      :close-on-click-modal="false">
      <el-form label-position="right" label-width="60px" :model="courseForm" :rules="courseRules" ref="courseForm">
        <el-form-item label="课程标题：" prop="courseTitle" required>
          <el-input style="width: 500px" v-model="courseForm.courseTitle" placeholder="请输入课程名称"></el-input>
        </el-form-item>
        <el-form-item label="课程副标题：">
          <el-input style="width: 500px" v-model="courseForm.courseSubtitle" placeholder="请输入课文标题"></el-input>
        </el-form-item>
        <el-form-item label="首页课程封面：" required>
          <el-row type="flex">
            <el-col :span="15">
              <el-upload :action="uploadImg" name="file" :show-file-list="false" :headers="headers" drag
                :on-success="(res) => imgSuccess(res, 'coverImageUrlFirst')">
                <div v-if="!courseForm.coverImageUrlFirst">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </div>
                <div v-else class="image-container">
                  <img class="uploaded-image" :src="courseForm.coverImageUrlFirst" alt="" />
                </div>
              </el-upload>
            </el-col>
            <el-col :span="5" :offset="2">
              <div class="main-red up-tip">(封面图尺寸为:59px X 73px)</div>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="课程详情页图片：">
          <el-row type="flex">
            <el-col :span="15">
              <el-upload :action="uploadImg" name="file" :show-file-list="false" :headers="headers" drag
                :on-success="(res) => imgSuccess(res, 'coverImageUrlSecond')">
                <div v-if="!courseForm.coverImageUrlSecond">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </div>
                <div v-else class="image-container">
                  <img class="uploaded-image" :src="courseForm.coverImageUrlSecond" alt="" />
                </div>
              </el-upload>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="课程推荐标签：">
          <el-select v-model="courseForm.labelName" :multiple-limit="3" placeholder="请选择标签" multiple>
            <el-option v-for="item in labelList" :key="item.labelId" :label="item.labelName" :value="item.labelId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程分类：">
          <el-cascader placeholder="请选择课文分类" v-model="courseForm.categoryId" :options="courseCategory"
            :props="{ expandTrigger: 'hover', emitPath: false, checkStrictly: true }" clearable> </el-cascader>
        </el-form-item>
        <el-form-item label="运营标签：">
          <div style="display: flex">
            <el-input style="margin-right: 20px" v-model="cl[0]"></el-input>
            <el-input style="margin-right: 20px" v-if="cl.length > 1" v-model="cl[1]"></el-input>
            <el-input style="margin-right: 20px" v-if="cl.length == 3" v-model="cl[2]"></el-input>
            <div v-if="cl.length < 3" @click="() => { cl.push(''); }">+</div>
          </div>
        </el-form-item>
        <el-form-item label="课程学习顺序：">
          <el-select v-model="courseForm.learnSequenceType" placeholder="请选择课程学习顺序">
            <el-option v-for="item in learnList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
          <span class="ml20">不选默认按顺序学习</span>
        </el-form-item>

        <el-form-item label="推送用户类型：">
          <el-select v-model="courseForm.userType" placeholder="请选择标签" multiple>
            <el-option v-for="item in userTypeOpt" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="操作系统：">
          <el-select v-model="courseForm.systemType" placeholder="请选择标签" multiple>
            <el-option v-for="item in systemTypeOpt" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="课程特色说明：">
          <el-input style="width: 500px" type="textarea" autosize v-model="courseForm.description"
            placeholder="请输入课程特色说明"></el-input>
        </el-form-item>

        <el-form-item label="课程宣传图片：">
          <el-upload :action="uploadImg" name="file" :show-file-list="false" :headers="headers" drag
            :on-success="(res) => imgSuccess(res, 'leafletImageUrl')">
            <div v-if="!courseForm.leafletImageUrl">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </div>
            <div v-else class="image-container">
              <img class="uploaded-image" :src="courseForm.leafletImageUrl" alt="" />
            </div>
          </el-upload>
        </el-form-item>

        <classCommon title="课程" @saveData="setClass" :list="courseForm.classRecommend">
        </classCommon>

        <!-- 相关课程 -->
        <relativeRecommendCommon :type="1" title="课程" @saveData="setRecommend" :list="courseForm.courseRecommend">
        </relativeRecommendCommon>

        <!-- 相关文章 -->
        <relativeRecommendCommon :type="2" title="文章" @saveData="setRecommend" :list="courseForm.articleRecommend">
        </relativeRecommendCommon>

        <!-- 相关直播 -->
        <relativeRecommendCommon :type="3" title="直播" @saveData="setRecommend" :list="courseForm.liveRecommend">
        </relativeRecommendCommon>

        <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px; margin-right: 30px">
          <el-button type="primary" plain @click="submitForm()">保存</el-button>
          <el-button type="danger" plain @click="() => (addVisible = false)">取消</el-button>
        </div>
      </el-form>
    </el-dialog>

  </div>
</template>
<script>
import DyTable from '@/components/common/dytable';
import classCommon from '../components/classCommon/index';
import relativeRecommendCommon from '../components/relativeRecommendCommon/index';

import host from '@/api/index';
import { saveCourse, listLecturer } from '@/api/index2';
import { learnList } from '@/utils/commonData';
import { isJSON, formatDate } from '@/utils/utils';


export default {
  name: 'studyDialog',
  components: {
    DyTable,
    classCommon,
    relativeRecommendCommon,
  },
  props: {
    dialogTitle: {
      type: String,
      default: '新建课程',
    },
    _courseForm: {
      type: Object,
      default() {
        return {};
      },
    },
    labelList: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    uploadImg() {
      return host.uploadImgUrl;
    },
    headers() {
      return {
        'bg-token': localStorage.getItem('token'), // 直接从本地获取token就行
      };
    },
  },

  watch: {
    _courseForm: {
      handler(newVal, oldVal) {

        this.courseForm = { ...newVal };

        this.courseForm.learnSequenceType = this.courseForm.learnSequenceType || this.learnList[0].value;


        if (isJSON(this.courseForm.customizeLabelName)) {
          this.cl = JSON.parse(this.courseForm.customizeLabelName);
        } else if (Object.prototype.toString.call(this.courseForm.customizeLabelName) === '[object String]') {
          this.cl = this.courseForm.customizeLabelName.split(',');
        } else {
          this.cl = [];
        }

        this.courseForm.courseRecommend = this.courseForm.courseList || [];
        for (let e of this.courseForm.courseRecommend) {
          e.recommendId = e.recommendId || e.id;
          e.recommendName = e.recommendName || e.courseTitle;
          e.recommendCategory = e.recommendCategory || e.categoryName;
          e.recommendUser = e.recommendUser || e.bgUserName;
          e.recommendTime = e.recommendTime || formatDate(new Date(e.updateDateline * 1000), 'yyyy-MM-dd hh:mm:ss');
          e.recommendType = 1;
          delete e['id'];
        }

        this.courseForm.articleRecommend = this.courseForm.articleList || [];
        for (let e of this.courseForm.articleRecommend) {
          e.recommendId = e.recommendId || e.id;
          e.recommendName = e.recommendName || e.title;
          e.recommendCategory = e.recommendCategory || e.classificationName;
          e.recommendUser = e.recommendUser || e.author;
          e.recommendTime = e.recommendTime || formatDate(new Date(e.publishtime), 'yyyy-MM-dd hh:mm:ss');
          e.recommendType = 2;
          delete e['id'];
        }

        this.courseForm.liveRecommend = this.courseForm.liveList || [];
        for (let e of this.courseForm.liveRecommend) {
          e.recommendId = e.recommendId || e.id;
          e.recommendName = e.recommendName || e.liveName;
          e.recommendCategory = e.recommendCategory || e.categoryName;
          e.recommendUser = e.recommendUser || e.userNickName;
          e.recommendTime = e.recommendTime || e.updateTime;
          e.recommendType = 3;
          delete e['id'];
        }

        this.courseForm.classRecommend = this.courseForm.classList || [];
        for (let e of this.courseForm.classRecommend) {
          e.recommendId = e.recommendId || e.classId;
          e.updateTime = formatDate(new Date(e.updateTime), 'yyyy-MM-dd hh:mm:ss');
          e.recommendType = 4;
        }

        console.log('this.courseForm :>> ', this.courseForm);

        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
      deep: true,
    },
  },
  data() {
    return {
      learnList,

      courseCategory: [],

      addVisible: false,
      addLoading: false,

      speakerList: [],
      cl: [],
      courseForm: {
        id: '',
        name: '',
        userType: '',
        platform: '',
        weight: '',
      },
      courseRules: {
        courseTitle: [
          { required: true, message: '请输入课程名称', trigger: 'blur' },
          { required: true, message: '请输入课程名称', trigger: 'change' },
        ],
      },

      userTypeOpt: [
        // {
        //     label: "全部",
        //     value: "0"
        // },
        {
          label: '学生',
          value: '1',
        },
        {
          label: '教师',
          value: '2',
        },
        {
          label: '家长',
          value: '3',
        },
      ],
      systemTypeOpt: [
        // {
        //     label: "全部",
        //     value: "0"
        // },
        {
          label: 'iOS',
          value: '1',
        },
        {
          label: 'Android',
          value: '2',
        },
        {
          label: 'HarmonyOS',
          value: '3',
        },
        {
          label: 'PC',
          value: '4',
        },
      ],
    };
  },
  created() { },
  mounted() {
    this.getCourseCategory();
    this.getSpeakerList();
  },
  methods: {
    async getCourseCategory() {
      this.courseCategory = await this.$store.dispatch('category/getCourseCategory');
    },

    // 图片更新
    imgSuccess(file, key) {
      console.log(key, file);
      // this.courseForm[key] = file.data.url;
      this.$set(this.courseForm, key, file.data.url);
    },

    setRecommend(param) {
      switch (param.type + 0) {
        // 1 相关课程
        case 1:
          this.courseForm.courseRecommend = param.data;
          break;
        // 2 相关文章
        case 2:
          this.courseForm.articleRecommend = param.data;
          break;
        // 推荐直播
        case 3:
          this.courseForm.liveRecommend = param.data;
          break;
        default:
          break;
      }
    },
    setClass(param) {
      this.courseForm.classRecommend = param.data;
    },
    // 提交表单
    submitForm() {
      this.$refs.courseForm.validate((valid) => {
        if (valid) {

          if (this.courseForm.courseRecommend && this.courseForm.courseRecommend.length > 3) {
            this.$message({
              message: '最多可以选择三个相关课程推荐，请删除多余课程',
              type: 'warning',
            });
            return;
          } else if (this.courseForm.articleRecommend && this.courseForm.articleRecommend.length > 3) {
            this.$message({
              message: '最多可以选择三个相关文章推荐，请删除多余文章',
              type: 'warning',
            });
            return;
          } else if (this.courseForm.liveRecommend && this.courseForm.liveRecommend.length > 3) {
            this.$message({
              message: '最多可以选择三个相关直播推荐，请删除多余直播',
              type: 'warning',
            });
            return;
          } else if (!this.courseForm.coverImageUrlFirst) {
            this.$message({
              message: '请上传首页课程封面',
              type: 'warning',
            });
            return;
          }

          this.addLoading = true;
          var info = this.courseForm;
          let labelName = this.labelList.filter((item) => new Set(info.labelName).has(item.labelId)).map((item) => item.labelName);
          info.labelName = JSON.stringify(labelName);
          info.type = 1;


          info.userType = info.userType.join(',');
          if (info.userType == '') {
            info.userType = '1,2,3';
          }
          info.systemType = info.systemType.join(',');
          if (info.systemType == '') {
            info.systemType = '1,2,3,4';
          }
          let cla = this.cl.filter((item) => item !== '');
          info.customizeLabelName = cla.join(',');

          console.log('info. :>> ', info.classRecommend);
          saveCourse(info).then((res) => {
            if (res.result == 1) {
              this.addVisible = false;
              this.$emit('getList');
              this.$message({
                showClose: true,
                message: '保存成功',
                type: 'success',
              });
              this.addLoading = false;
            } else {
              this.$message({
                showClose: true,
                message: res.msg,
                type: 'error',
              });
              this.addLoading = false;
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    //获取主讲人列表
    getSpeakerList() {
      let info = {
        needPage: false,
      };
      listLecturer(info).then((res) => {
        if (res.result == 1) {
          this.speakerList = res.data;
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
  },
};
</script>
<style scoped>
/* 图片容器居中显示 */
.image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  height: 180px;
  overflow: hidden;
}

.uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 4px;
}

.ml20 {
  margin-left: 20px;
}
</style>
